import { formatIssueHeadline, readIssueCounts } from '../work';

import type { HomeQueueRow } from './homeQueues';

export interface IssueSummary {
  blocking: boolean;
  headline: string;
  detail: string;
}

/**
 * The blocker or flag the biller has to clear, headline first: "2 blockers",
 * then the first finding's own sentence, or the top submission or legacy
 * blocker when the row carries no finding.
 */
export const issueSummary = (item: HomeQueueRow): IssueSummary => {
  const counts = readIssueCounts(item);
  return {
    blocking: counts.blockers > 0,
    detail:
      item.finding_highlights?.[0]?.why ??
      item.submission_top_blocker ??
      item.legacy_top_blocker ??
      '',
    headline: formatIssueHeadline(counts),
  };
};
